
























import Vue from "vue";
import { AuthenticationService } from "@/services/authenticationService";

export default Vue.extend({
  props: {
    accessToken: {
      type: String,
      default: null
    },
    to: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      errorMessage: null,
      noTokenProvided: true
    };
  },
  mounted() {
    this.authenticateWithToken();
  },
  methods: {
    authenticateWithToken(): any {
      if (AuthenticationService.isAuthenticated()) {
        AuthenticationService.singOut();
      }
      AuthenticationService.saveToken(this.accessToken);
      this.$router.push("/" + this.to);
    }
  }
});
